// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4196":"css/app.6667","8014":"css/admin-app.6667"}[chunkId] + ".css";
};